var _90d_acf_google_map = {

  loadGoogleMapsApi: function () {
    if (typeof google === "undefined") {

      window._90dl_google_maps_api_key = typeof window._90dl_google_maps_api_key === 'undefined' ? 'none' : window._90dl_google_maps_api_key;

      var script = document.createElement("script");
      script.src = "https://maps.googleapis.com/maps/api/js?key=" + window._90dl_google_maps_api_key + "&libraries=places&ver=3&callback=_90d_acf_google_map.loadGoogleMapsApiReady";
      document.getElementsByTagName("head")[0].appendChild(script);
    } else {
      loadGoogleMapsApiReady();
    }
  },

  loadGoogleMapsApiReady: function () {
    $(window).trigger("google_map_api_ready");
  },

  render_map: function ($el) {

    var $markers = $el.find('.marker');

    var $firstMarker = $el.find('.marker')[0];

    var args = {
      zoom: 13,
      center: new google.maps.LatLng(0, 0),
      scrollwheel: false,
      mapTypeIds: [google.maps.MapTypeId.ROADMAP],
      streetViewControlOptions: {
        position: google.maps.ControlPosition.RIGHT_CENTER
      },
      zoomControlOptions: {
        position: google.maps.ControlPosition.RIGHT_CENTER
      },
      styles: [{
        featureType: 'poi.business',
        elementType: 'all',
        stylers: [{
          visibility: 'off'
        }]
      }]
    };

    var map = new google.maps.Map($el[0], args);
    map.markers = [];

    $markers.each(function () {
      _90d_acf_google_map.add_marker($(this), map);
    });

    if (typeof window.map_tint_colour !== 'undefined' && window.map_tint_colour !== false) {

      map.setOptions({
        styles: [{
          "featureType": "all",
          "elementType": "all",
          "stylers": [{
              "hue": window.map_tint_colour
            },
            {
              "saturation": 100
            },
            {
              "lightness": -10
            },
            {
              "gamma": 1.1
            }
          ]
        }]
      });

    }

    //google.maps.event.addListenerOnce(map, 'idle', function(){
    //google.maps.event.trigger(map, 'resize');
    _90d_acf_google_map.center_map(map);
    //});

    // initialize transit 
    _90d_acf_google_map.transport_layer($el, map);



    // initialize directions 
    _90d_acf_google_map.directions($el, map, $firstMarker);


  },

  add_marker: function ($marker, map) {

    var latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));

    var marker_icon = (typeof $marker.attr('data-icon') !== 'undefined') ? $marker.attr('data-icon') : 'http://www.google.com/mapfiles/marker.png';

    var marker = new google.maps.Marker({
      position: latlng,
      map: map,
      animation: google.maps.Animation.DROP,
      icon: marker_icon
    });

    map.markers.push(marker);

  },

  center_map: function (map) {

    var bounds = new google.maps.LatLngBounds();

    $.each(map.markers, function (i, marker) {
      var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
      bounds.extend(latlng);
    });

    if (map.markers.length == 1) {
      map.setCenter(bounds.getCenter());
      map.setZoom(14);
    } else {
      map.fitBounds(bounds);
    }
  },

  directions: function ($el, map, $firstMarker) {

    var directionDisplay;
    var mapDirections = new google.maps.DirectionsService();
    var directMap;

    //initialize new Directions DirectionsRenderer object
    directionDisplay = new google.maps.DirectionsRenderer();
    directMap = map;
    directionDisplay.setMap(directMap);

    // Create on change event to postcode input field
    var postcode = document.getElementById('postcode');

    if (postcode) {
      postcode.addEventListener('change', function (e) {

        var latVal, lngVal, startPoint, endPoint, request;

        latVal = parseFloat($firstMarker.getAttribute("data-lat"));
        lngVal = parseFloat($firstMarker.getAttribute("data-lng"));

        startPoint = postcode.value;
        endPoint = new google.maps.LatLng(latVal, lngVal);

        //Build request object for Directions API    
        request = {
          origin: startPoint,
          destination: endPoint,
          provideRouteAlternatives: true,
          travelMode: 'DRIVING',
          unitSystem: google.maps.UnitSystem.IMPERIAL
        };

        //set up a message
        var message = document.getElementById('message');
        var instructions = document.getElementById('postcode_instructions');
        var country;
        var geocoder = new google.maps.Geocoder();

        geocoder.geocode({
          'address': postcode.value
        }, function (results, status) {

          if (status == 'OK') {
            var address_parts = results[0].address_components.filter(function (address_parts) {
              return address_parts.short_name === 'GB' || address_parts.short_name === 'ENGLAND' || address_parts.short_name === 'SCOTLAND' || address_parts.short_name === 'WALES';
            })[0];

            if (typeof address_parts != 'undefined') {
              //we should be in UK
              mapDirections.route(request, function (result, status) {

                //Check API response is OK
                if (status == 'OK') {
                  message.innerHTML = 'Estimate driving time: ' + result.routes[0].legs[0].duration.text;
                  directionDisplay.setDirections(result);
                  instructions.innerText = '';
                  message.innerHTML = '<a id="launch_directions" class="button small">Show steps</a><a id="map_clear" class="button small">Clear Map</a>';
                  _90d_acf_google_map.display_turns(result, map, directionDisplay);

                } else if (status == 'ZERO_RESULTS') {
                  message.innerText = 'No results found - please try again';
                }
              });
            } else {
              message.innerHTML = 'You appear to have entered an incorrect/non-UK postcode, please try again';
            }
          } else {
            message.innerHTML = 'You appear to have entered an incorrect postcode, please try again';
          }
        });
      }, false);
    }
  },

  display_turns: function (result, map, display) {

    //get launch button
    var launch_button = document.getElementById('launch_directions');
    var clearer = document.getElementById('map_clear');

    //get accordion to hide
    var accordion = document.getElementById('connectivity_accordion');

    //create panel
    var dir_container = document.getElementById('connectivity_sidebar');
    var panel = document.createElement('div');
    panel.id = 'directions_panel';
    panel.className += 'hidden';

    //loop through results and add to panel
    var moves = result.routes[0].legs[0].steps;
    var html, turn;
    for (var i = 0; i < moves.length; i++) {
      html = '<span class="number">' + (i + 1) + '</span><span class="instruction">' + moves[i].instructions + '</span><span class="duration"> for ' + moves[i].duration.text + ' </span>';
      turn = document.createElement('p');
      turn.innerHTML = html;
      panel.appendChild(turn);
    }

    //add directions to DOM
    dir_container.appendChild(panel);

    //button click to reveal
    if (launch_button.length || typeof launch_button != 'undefined') {
      launch_button.addEventListener('click', function () {
        if (launch_button.classList.contains('directions-hide')) {
          //dir are showing, so show accordion instead
          this.innerText = 'Show Steps';
          this.classList.remove('directions-hide');
          panel.classList.add('hidden');
          accordion.classList.remove('hidden');
        } else {
          //dir become visible, hide accordion
          panel.classList.remove('hidden');
          accordion.className += ' hidden';
          this.innerText = 'Hide Steps';
          this.className += ' directions-hide';
        }
      });
    }

    //button click to clear
    if (clearer.length || typeof clearer != 'undefined') {
      clearer.addEventListener('click', function () {
        _90d_acf_google_map.center_map(map);
        display.setMap(null);
      });
    }



  },

  transport_layer: function ($el, map) {
    var transit_layer = new google.maps.TransitLayer();

    //kml layers
    var triggers = document.getElementsByClassName("transit-trigger");
    var src;
    var kmlLayer;
    for (var i = 0; i < triggers.length; i++) {
      triggers[i].addEventListener('click', function (e) {
        // if(transit_layer.getMap()) {
        //   transit_layer.setMap(null);
        // } else {
        transit_layer.setMap(map);
        // }
        var urlSuffix = (new Date).getTime().toString();
        src = this.dataset.layer + '?' + urlSuffix;
        kmlLayer = new google.maps.KmlLayer({
          url: src,
          map: map,
          preserveViewport: true
        });
        kmlLayer.setMap(map);
      });
    }

  }
};